import { Injectable, Injector } from '@angular/core';
import { ObservableWrapperService } from './observable-wrapper.service';

@Injectable({
    providedIn: 'root',
})
export class ObservableWrapperResolverService {
    constructor(private _injector: Injector) {}

    public get wrapper(): ObservableWrapperService {
        return this._injector.get(ObservableWrapperService);
    }
}
